export default "__VITE_ASSET__tIk6j8mw__"